import { useUser } from "./use-user";

export const useAuthorizedValue = <T>(
	value: T,
	permissions: string | string[],
	fallback: T | null = null,
): T | null => {
	const { hasAnyRole } = useUser();

	const matchedRoles = hasAnyRole(Array.isArray(permissions) ? permissions : [permissions]);

	if (matchedRoles === undefined) {
		return null;
	}

	if (matchedRoles) {
		return value;
	}

	return fallback;
};
